import React from 'react';
import { Link } from 'react-router-dom';
import { ClapperboardIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy text-white" role="contentinfo" data-id="element-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-id="element-21">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-8" data-id="element-22">
          {/* Brand Column */}
          <div data-id="element-23">
            <div className="flex items-center gap-2.5 mb-4" data-id="element-24">
              <div className="w-8 h-8 bg-amber/20 rounded-lg flex items-center justify-center" data-id="element-25">
                <ClapperboardIcon className="w-4 h-4 text-amber" aria-hidden="true" data-id="element-26" />
              </div>
              <span className="font-serif font-semibold text-lg text-white tracking-tight" data-id="element-27">
                Slate & Page
              </span>
            </div>
            <p className="font-sans text-sm text-white/60 leading-relaxed max-w-xs" data-id="element-28">
              Your story's second brain. The development layer between you and
              your screenplay.
            </p>
            <div className="mt-6 flex items-center gap-1.5" data-id="element-29">
              <span className="inline-block w-2 h-2 rounded-full bg-amber/60" data-id="element-30"></span>
              <span className="font-sans text-xs text-white/40 uppercase tracking-widest" data-id="element-31">
                Early Access
              </span>
            </div>
          </div>

          {/* Product Links */}
          <div data-id="element-32">
            <h3 className="font-sans text-xs font-semibold uppercase tracking-widest text-white/40 mb-5" data-id="element-33">
              Product
            </h3>
            <ul className="space-y-3" role="list" data-id="element-34">
              <li data-id="element-35">
                <Link to="/features" className="font-sans text-sm text-white/70 hover:text-white transition-colors" data-id="element-36">
                  Features
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/pricing" className="font-sans text-sm text-white/70 hover:text-white transition-colors" data-id="element-38">
                  Pricing
                </Link>
              </li>
              <li data-id="element-39">
                <Link to="/waitlist" className="font-sans text-sm text-white/70 hover:text-white transition-colors" data-id="element-40">
                  Join Waitlist
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div data-id="element-41">
            <h3 className="font-sans text-xs font-semibold uppercase tracking-widest text-white/40 mb-5" data-id="element-42">
              Company
            </h3>
            <ul className="space-y-3" role="list" data-id="element-43">
              <li data-id="element-44">
                <Link to="/about" className="font-sans text-sm text-white/70 hover:text-white transition-colors" data-id="element-45">
                  About
                </Link>
              </li>
              <li data-id="element-46">
                <a href="mailto:hello@slateandpage.com" className="font-sans text-sm text-white/70 hover:text-white transition-colors" data-id="element-47">
                  Contact
                </a>
              </li>
              <li data-id="element-48">
                <Link to="/legal" className="font-sans text-sm text-white/70 hover:text-white transition-colors" data-id="element-49">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/legal#terms" className="font-sans text-sm text-white/70 hover:text-white transition-colors" data-id="element-51">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-52">
          <p className="font-sans text-xs text-white/40" data-id="element-53">
            © {currentYear} Slate & Page. All rights reserved.
          </p>
          <p className="font-sans text-xs text-white/40 flex items-center gap-1.5" data-id="element-54">
            <span className="text-amber" data-id="element-55">✦</span>
            Made for writers
          </p>
        </div>
      </div>
    </footer>;
}